import React from "react";
import { useRaffleWheel } from "./RaffleWheelContext";
import { PIN_SIZE, PIN_SMALL_Y_OFFSET } from "./wheelMath";
import cls from "./styles.module.scss";

export const WheelPin = () => {
  const { baseViewportScale, center } = useRaffleWheel();
  const pinCenterX = center;
  const pinCenterY = center - PIN_SMALL_Y_OFFSET * 1.2;
  const renderedPinSize = PIN_SIZE * baseViewportScale;
  const renderedPinCenterX = pinCenterX * baseViewportScale;
  const renderedPinCenterY = pinCenterY * baseViewportScale;

  return (
    <span
      className={cls.centerPin}
      style={{
        left: `${renderedPinCenterX - renderedPinSize / 2}px`,
        top: `${renderedPinCenterY - renderedPinSize / 2}px`,
        width: `${renderedPinSize}px`,
        height: `${renderedPinSize}px`,
      }}
    >
      <img src="/goals/wheelCenter.webp" alt="" />
    </span>
  );
};
